.message-content {
  display: block;
  color: var(--rc-theme-color-text-default);

  &.message-content--center {
    text-align: center;
  }

  &.message-content--left {
    text-align: left;
  }

  &.message-content--right {
    text-align: right;
  }
}
